import React from 'react'
import RuleMapRow from './RuleMapRow'
import withView from '../../../cmn/docAutomation/withView';
import FormTitle from '../../../../library/form/components/FormTitle'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../library/layout/Index";

const RuleMap = (props) => {
    const { formObject, viewData } = props;
    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span>
                        <FormTitle formObject={formObject} value='Rule Map' />
                    </span>
                </UiTitle>
                <UiAction>
                    <FormButton formObject={formObject} id="newAddButton" ksc="alt+n" rowKey=""
                        action={{ actionId: "new",  actionParam: {}, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Add Tag" />}></FormButton>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <ul className="uiListTable">
                    <li className="uiSearchHeading">
                        <span className="uiColumn uiColumn150"><sarasTrans value="Tag Type" /></span>
                        <span className="uiColumn uiColumn200"><sarasTrans value="Tag" /></span>
                        <span className="uiColumn uiColumn200"><sarasTrans value="Action" /></span>
                    </li>
                    {
                        Object.values(viewData).map((row, index) => (
                            <RuleMapRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default withView(RuleMap, "ruleTag", "ruleTag")